import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PaperSwitch from '@material-ui/core/Switch';
import {Nav} from '@deere/ux.uxframe-react';
import PropTypes from 'prop-types';
import {GERMANY_COUNTRY_CODE, SPAIN_COUNTRY_CODE, UK_COUNTRY_CODE, PORTUGAL_COUNTRY_CODE} from '../ESignature/Constants/constants';

const TranslateTab = ({translateToEnglishSwitchHandler, user}) => {
    const onChangeHandler = (event) => {
        const branchCode = (event.target.checked) ? UK_COUNTRY_CODE : user.branchCode;
        translateToEnglishSwitchHandler(branchCode);
    }

    const isSpanishOrGermanUser = () => {
        return user && (user.branchCode.slice(0, 2).toUpperCase() === SPAIN_COUNTRY_CODE || user.branchCode.slice(0, 2).toUpperCase() === GERMANY_COUNTRY_CODE || user.branchCode.slice(0, 2).toUpperCase() === PORTUGAL_COUNTRY_CODE);
    }

    return (
        <>
            {isSpanishOrGermanUser() &&
                <Nav.Item>
                    <FormControlLabel
                        control={
                            <PaperSwitch
                                color="primary"
                                onChange={onChangeHandler}
                            />
                        }
                        label="Translate to English"
                    />
                </Nav.Item>
            }
        </>
    );
}

TranslateTab.propTypes = {
    translateToEnglishSwitchHandler: PropTypes.func.isRequired,
    user: PropTypes.object
}

export default TranslateTab;
